/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 (function($) {


 	openModal = function() {
 		$('.open--modal').magnificPopup({
 			type: 'inline'
 		});
 	};

 	headerImage = function() {
 		$('.headerimage').slick({
 			dots: true,
 			customPaging : function(slider, i) {
 				return '<span></span>';
 			},
 			infinite: true,
 			slidesToShow: 1,
 			arrows: false,
 			autoplay: true,
 			autoplaySpeed: 7000,
 			fade: true,
 			slidesToScroll: 1,
 			cssEase: 'linear'
 		});
 		$('.slick-dots').wrap('<div class="slick-dots-wrapper"></div>');
 	};


 	uspSlider = function() {
 		$('.usp__image .images').slick({
 			dots: true,
 			customPaging : function(slider, i) {
 				return '<span></span>';
 			},
 			infinite: true,
 			slidesToShow: 1,
 			arrows: false,
 			autoplay: true,
 			autoplaySpeed: 7000,
 			adaptiveHeight: false,
 			fade: true,
 			slidesToScroll: 1,
 			cssEase: 'linear'
 		});
 	};

 	/*----------  Open image url`s in popup  ----------*/
 	function showImageModal() {
 		$('.content a').each(function(i, el) {
 			if(! $(this).parents().hasClass('content--gallery')) {
 				var href_value = el.href;
 				if (/\.(jpg|png|gif)$/.test(href_value)) {
 					$(this).magnificPopup({
 						type: 'image',
 						closeOnContentClick: true,
 						mainClass: 'mfp-img-mobile',
 						image: {
 							verticalFit: true
 						}
 					});
 				} 
 			}
 		});

 		$('.content--gallery ul').each(function(i, el) {
 			$(this).magnificPopup({
	        delegate: 'a', /* the selector for gallery item */
	        type: 'image',
	        gallery: {
	        	enabled:true
	        }
	    });
 		});
 	}


 	/*----------  On scroll  ----------*/
 	$(window).scroll(function() {
 	});

 	var waitForFinalEvent = (function () {
 		var timers = {};
 		return function (callback, ms, uniqueId) {
 			if (!uniqueId) {
 				uniqueId = "Don't call this twice without a uniqueId";
 			}
 			if (timers[uniqueId]) {
 				clearTimeout (timers[uniqueId]);
 			}
 			timers[uniqueId] = setTimeout(callback, ms);
 		};
 	})();

 	$(window).resize(function() {
 		waitForFinalEvent(function(){
 		}, 500);
 	});


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
    	init: function() {
    		/* JavaScript to be fired on all pages */
    		toggleNavigation();
    		scrollMenu();
    		toggleSubNav();
    		toggleSearch();

    		headerImage();
    		uspSlider();
    		
    		openModal();
    		showImageModal();

    		$('.article .article__content .dotdotdot').dotdotdot({
    			watch: "window"
    		});

    		$('select').select2({
    			minimumResultsForSearch: Infinity
    		});
    	},
    	finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    }
},
    // Home page
    'home': {
    	init: function() {
        // JavaScript to be fired on the home page
    },
    finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
    }
},
    // Contact page
    'page_template_contact_template': {
    	init: function() {
        // JavaScript to be fired on the about us page
        initMap();
    }
}
};

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
  	fire: function(func, funcname, args) {
  		var fire;
  		var namespace = Sage;
  		funcname = (funcname === undefined) ? 'init' : funcname;
  		fire = func !== '';
  		fire = fire && namespace[func];
  		fire = fire && typeof namespace[func][funcname] === 'function';

  		if (fire) {
  			namespace[func][funcname](args);
  		}
  	},
  	loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
      	UTIL.fire(classnm);
      	UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
  }
};

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
